import { takeLatest, put, take, race, select } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import * as getUser from './get-user';
import { createActions } from '../../utils/redux';
import createConsts from '../../utils/redux/consts';
import * as getAccessLevel from './getAccessLevels';
import * as getFamilyMember from './get-family-member';
import { loggedUserIdSelector } from '../context/selectors';
import { myProfileRedirectActions } from './my-profile-redirect';
import { actions as fetchPublicProfile } from './public-profile';
import { PROFILE, PATIENT_VIEW_PROFILE } from '../../constants/routes';

export const consts = createConsts(
  'profile',
  'public-profile',
  'GO_TO_PROFILE',
);
export const actions = createActions(consts);

// all user's relations for access to the patient profile
export const PATIENT_ACCESS_LEVEL = [
  'provider',
  'patient_caregiver',
  'family_member',
];

const canSeePatientProfile = payload => {
  return payload.some(role => PATIENT_ACCESS_LEVEL.includes(role));
};

function* redirectToProfile({ payload }) {
  const { id, isLoggedInUser } = payload;
  if (isLoggedInUser) {
    yield put(myProfileRedirectActions.goToProfile());
  } else {
    yield put(getAccessLevel.actions.send({ id }));
    const { payload: accessPayload } = yield take([
      getAccessLevel.consts.SUCCEED,
      getAccessLevel.consts.REJECTED,
    ]);
    if (Array.isArray(accessPayload) && canSeePatientProfile(accessPayload)) {
      yield put(getUser.actions.send({ id }));
      const { deniedMainProfile } = yield race({
        successMainProfile: take(getUser.consts.SUCCEED),
        deniedMainProfile: take(getUser.consts.REJECTED),
      });
      if (deniedMainProfile) {
        const loggedUserId = yield select(loggedUserIdSelector);
        yield put(getFamilyMember.actions.send({ id, userId: loggedUserId }));
        const { deniedFamilyProfile } = yield race({
          successFamilyProfile: take(getFamilyMember.consts.SUCCEED),
          deniedFamilyProfile: take(getFamilyMember.consts.REJECTED),
        });
        if (deniedFamilyProfile) {
          yield put(fetchPublicProfile.send({ id }));
        }
      } else {
        browserHistory.push(`/${PROFILE}/${id}/${PATIENT_VIEW_PROFILE}`);
      }
    } else {
      yield put(fetchPublicProfile.send({ id }));
    }
  }
}

export function* publicProfileRedirectSaga() {
  yield takeLatest(consts.GO_TO_PROFILE, redirectToProfile);
}



// WEBPACK FOOTER //
// ./src/redux/profiles/public-profile-redirect.js